module.exports = __webpack_public_path__ + "media/images/service/n_14-98eddb0100f35b98bc87971620f8bfa3.jpg";